/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */
// action
import * as actions from '../action/customers.action';
// state
import { customer, CustomerStateRecord } from './customers.state';

export const initialState: customer = new CustomerStateRecord() as unknown as customer;

export function reducer(state = initialState, { type, payload }: any): customer {
  if (!type) {
    return state;
  }

  switch (type) {
    // MEDIA UPLOAD FILE
    case actions.ActionTypes.PURCHASED_CUSTOMER_LIST: {
      return Object.assign({}, state, {
        purchasedCustomerListLoading: true,
        purchasedCustomerListLoaded: false,
        purchasedCustomerListFailed: false
      });
    }

    case actions.ActionTypes.PURCHASED_CUSTOMER_LIST_SUCCESS: {
      return Object.assign({}, state, {
        purchasedCustomerList: payload.data,
        purchasedCustomerListLoading: false,
        purchasedCustomerListLoaded: true,
        purchasedCustomerListFailed: false
      });
    }
    case actions.ActionTypes.PURCHASED_CUSTOMER_LIST_FAIL: {
      return Object.assign({}, state, {
        purchasedCustomerListLoading: false,
        purchasedCustomerListLoaded: true,
        purchasedCustomerListFailed: true
      });
    }

    case actions.ActionTypes.PURCHASED_CUSTOMER_LIST_COUNT: {
      return Object.assign({}, state, {
        purchaseCount: 0,
        purchaseCountLoading: true,
        purchaseCountLoaded: false,
        purchaseCountFailed: false
      });
    }

    case actions.ActionTypes.PURCHASED_CUSTOMER_LIST_COUNT_SUCCESS: {
      return Object.assign({}, state, {
        purchaseCount: payload.data,
        purchaseCountLoading: false,
        purchaseCountLoaded: true,
        purchaseCountFailed: false
      });
    }

    case actions.ActionTypes.PURCHASED_CUSTOMER_LIST_COUNT_FAIL: {
      return Object.assign({}, state, {
        purchaseCount: 0,
        purchaseCountLoading: false,
        purchaseCountLoaded: false,
        purchaseCountFailed: true
      });
    }
    default: {
      return state;
    }
  }
}


// Media upload
export const purchasedCustomerList = (state: customer) => state.purchasedCustomerList;
export const purchasedCustomerListLoading = (state: customer) =>
  state.purchasedCustomerListLoading;
export const purchasedCustomerListLoaded = (state: customer) =>
  state.purchasedCustomerListLoaded;
export const purchasedCustomerListFailed = (state: customer) =>
  state.purchasedCustomerListFailed;

  export const purchasedCount = (state: customer) => state.purchaseCount;
  export const purchasedCountLoading = (state: customer) =>
  state.purchaseCountLoading;
  export const purchasedCountLoaded = (state: customer) =>
  state.purchaseCountLoaded;
